<template>
  <div>

    <div class="mb-12">
      <div class="page-title mb-2">
        Requirement Form
      </div>

      <div class="txt-head font-weight-light black--text">
        แบบฟอร์มความต้องการเทคโนโลยี
      </div>
    </div>

    <div class="d-flex flex-column gap-12 mb-6">
      <!--  GENERAL  -->
      <divcard>
        <div class="card-part">
          <div class="txt-head black--text mb-2">
            <span class="theme-color-one">ส่วนที่ 1 :</span> ข้อมูลทั่วไป <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>

          <div>
            <!-- Form 1 #line1 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">คำนำหน้า</div>
                <div>{{ form.p1_title_name }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">ชื่อ</div>
                <div>{{ form.p1_first_name }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">นามสกุล</div>
                <div>{{ form.p1_last_name }}</div>
              </div>
            </div>

            <!-- Form 1 #line2 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">อายุ (ปี)</div>
                <div>{{ form.p1_age }}</div>
              </div>

              <div class="flex xs8">
                <div class="mb-1 black--text">หมายเลขบัตรประชาชน</div>
                <div>{{ form.p1_pid }}</div>
              </div>
            </div>

            <!-- Form 1 #line3 -->
            <div class="flex-center gap-16">
              <div class="flex xs12">
                <div class="mb-1 black--text">ที่อยู่/อาคาร/หมู่บ้าน</div>
                <div>{{ form.p1_addr }}</div>
              </div>
            </div>

            <!-- Form 1 #line4 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">จังหวัด</div>
                <div>{{ form.p1_addr_pid }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">เขต/อำเภอ</div>
                <div>{{ form.p1_addr_did }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">แขวง/ตำบล</div>
                <div>{{ form.p1_addr_sdid }}</div>
              </div>
            </div>

            <!-- Form 1 #line5 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">รหัสไปรษณีย์</div>
                <div>{{ form.p1_addr_postcode }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">โทรศัพท์</div>
                <div>{{ form.p1_phone }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">โทรศัพท์มือถือ</div>
                <div>{{ form.p1_mobile_phone }}</div>
              </div>
            </div>

            <!-- Form 1 #line6 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">โทรสาร</div>
                <div>{{ form.p1_fax }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">อีเมล</div>
                <div>{{ form.p1_email }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">เว็บไซต์</div>
                <div>{{ form.p1_website }}</div>
              </div>
            </div>

            <!-- Form 1 #line7 -->
            <div class="d-flex align-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">ตำแหน่งในองค์กร</div>
                <div>{{ form.p1_position }}</div>
              </div>

              <div class="flex shrink flex-center gap-12">
                <div class="mb-1 black--text">อำนาจในการตัดสินใจเข้าร่วมโครงการ</div>
                <div>{{ form.p1_authority ? 'มี' : 'ไม่มี' }}</div>
              </div>
            </div>

          </div>
        </div>

        <div class="card-part">
          <div class="d-flex align-center gap-12">
            <div class="mb-1 txt-head black--text">ข้อมูลสถานประกอบการ</div>
            <div>{{ form.p1_same_addr ? 'ตั้งอยู่ที่เดียวกัน' : 'ตั้งอยู่คนละที่' }}</div>
          </div>

          <!-- Form 2 -->
          <div v-if="!form.p1_same_addr">
            <!-- Form 2 #line1 -->
            <div class="flex-center gap-16">
              <div class="flex xs12">
                <div class="mb-1 black--text">ที่อยู่/อาคาร/หมู่บ้าน</div>
                <div>{{ form.p1_org_addr }}</div>
              </div>
            </div>

            <!-- Form 2 #line2 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">จังหวัด</div>
                <div>{{ form.p1_org_pid }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">เขต/อำเภอ</div>
                <div>{{ form.p1_org_did }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">แขวง/ตำบล</div>
                <div>{{ form.p1_org_sdid }}</div>
              </div>
            </div>

            <!-- Form 2 #line3 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">รหัสไปรษณีย์</div>
                <div>{{ form.p1_org_postcode }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">โทรศัพท์</div>
                <div>{{ form.p1_org_phone }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">โทรศัพท์มือถือ</div>
                <div>{{ form.p1_org_mobile_phone }}</div>
              </div>
            </div>

            <!-- Form 2 #line4 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">โทรสาร</div>
                <div>{{ form.p1_org_fax }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">อีเมล</div>
                <div>{{ form.p1_org_email }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">เว็บไซต์</div>
                <div>{{ form.p1_org_website }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-part">
          <div class="txt-head black--text mb-3">
            สถานะ
          </div>
          <!-- Form 3 -->
          <div>
            <!-- Form 3 #line1 -->
            <div class="flex-center gap-16">
              <div class="flex">
                <div>{{ form.p1_personal_status }}</div>
              </div>
            </div>
          </div>
        </div>
      </divcard>


      <!--  BUSINESS  -->
      <divcard>
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลการประกอบการ/ศักยภาพความพร้อม <span
            class="theme-color-seven txt-normal">(ถ้ามี)</span>
        </div>

        <!-- Form 1 -->
        <div>
          <!-- Form 1 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">เลขทะเบียน นิติบุคคล/ทะเบียนการค้า (ถ้ามี)</div>
              <div>{{ form.p2_reg_no }}</div>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">วิสาหกิจชุมชน (ถ้ามี)</div>
              <div>{{ form.p2_comm_ent }}</div>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">OTOP (ถ้ามี)</div>
              <div>{{ form.p2_otop }}</div>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">อื่น ๆ โปรดระบุ</div>
              <div>{{ form.p2_reg_other }}</div>
            </div>
          </div>
        </div>

        <div class="card-part">
          <div>
            <!-- Form 2 #line1 -->
            <div class="flex-center gap-16">
              <div class="flex xs6">
                <div class="mb-1 black--text">ทุนจดทะเบียน/การระดมหุ้น (บาท)</div>
                <div>{{ form.p2_reg_cap }}</div>
              </div>

              <div class="flex xs6">
                <div class="mb-1 black--text">คนไทยถือหุ้นร้อยละ</div>
                <div>{{ form.p2_thai_share_pct }}</div>
              </div>
            </div>

            <!-- Form 2 #line2 -->
            <div class="flex-center gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">ปีที่จดทะเบียน (พ.ศ.)</div>
                <div>{{ form.p2_reg_year }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">ปีที่ก่อตั้ง (พ.ศ.)</div>
                <div>{{ form.p2_est_year }}</div>
              </div>

              <div class="flex xs4">
                <div class="mb-1 black--text">จำนวนพนักงาน/สมาชิก (คน)</div>
                <div>{{ form.p2_emp_count }}</div>
              </div>
            </div>

          </div>
        </div>

        <div class="card-part">
          <!-- Form 3 -->
          <div>
            <!-- Form 3 #line1 -->
            <div class="d-flex gap-16">
              <div class="flex xs4">
                <div class="mb-1 black--text">การจดทะเบียนทรัพย์สินทางปัญญา</div>
              </div>

              <div>{{ form.p2_ip_status }}</div>

              <div class="flex">
                <div class="d-flex justify-space-between gap-12">
                  <div class="flex xs6">
                    <div>{{ form.p2_ip_type }}</div>
                  </div>

                  <div class="flex xs6">
                    <div class="mb-2 black--text">เลขที่</div>
                    <div>{{ form.p2_ip_no }}</div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="card-part">
          <!-- Form 4 -->
          <div>
            <!-- Form 4 #line1 -->
            <div class="d-flex justify-space-between gap-16">
              <div class="flex xs4">
                <div>{{ form.p2_has_prod }}</div>
              </div>

              <div class="flex">
                <div>{{ form.p2_prod_idea }}</div>
              </div>
            </div>

            <!-- Form 4 #line2 -->
            <div class="d-flex justify-space-between gap-16">
              <div class="flex xs4">
                <div>{{ form.p2_prod_name }}</div>
              </div>

              <div class="flex d-flex justify-space-between gap-12">
                <div class="flex xs6">
                  <div class="mb-1 black--text">
                    มาตรฐานคุณภาพที่ได้รับ
                  </div>
                  <div>{{ form.p2_prod_qc }}</div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="card-part">
          <div>
            <div class="mb-1 black--text">
              ผลงานที่ผ่านมา
            </div>
            <div>{{ form.p2_past_works }}</div>
          </div>
        </div>
      </divcard>

      <divcard>
        <div class="card-part">
          <div class="txt-head black--text mb-2">
            <span class="theme-color-one">ส่วนที่ 3 :</span> ประเด็นปัญหาและความต้องการ <span
              class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>

          <!-- Form 1 -->
          <div class="checkbox-list mb-3">
            <div v-html="form.p3_issue_and_req ? form.p3_issue_and_req.join(', <br>') : '-'"></div>
            <div v-if="isOtherReq">
              อื่นๆ ระบุ: {{form.p3_req_other}}
            </div>
          </div>
        </div>

        <div class="card-part">
          <!-- Form 2 -->
          <div>
            <div class="d-flex align-center justify-space-between mb-3">
              <div class="black--text txt-head">ผู้กรอกข้อมูล</div>
            </div>
            <v-img
                eager
                height="150"
                :src="form.p3_signature"
            ></v-img>
          </div>
        </div>
      </divcard>
    </div>

    <!-- Action buttons -->
    <div class="d-flex justify-space-between">
      <Button theme="2" @onClick="$router.push({ name: 'RequirementList' })">ยกเลิก</Button>

      <div class="flex-center">
        <Button theme="3" min-width="120px" @onClick="backForm">&lt; ย้อนกลับ</Button>
        <Button theme="4" min-width="120px" @onClick="saveDraft">บันทึกฉบับร่าง</Button>
        <Button theme="3" min-width="120px" @onClick="nextForm">ถัดไป ></Button>
      </div>
    </div>

  </div>
</template>

<script>
import Button from "../../components/input/Button"

// import FormGeneral from "./FormGeneral"
// import FormBusiness from "./FormBusiness"
// import FormIssuesAndNeeds from "./FormIssuesAndNeeds"
import {eventBus} from "../../plugins/global-funcs"

export default {
  name: "RequirementPreview",
  components: {
    Button,
    // FormGeneral,
    // FormBusiness,
    // FormIssuesAndNeeds
  },
  data() {
    return {
      form: {},
      isOtherReq: false
    }
  },
  created() {
    this.retrieveForms()
  },
  methods: {
    backForm() {
      if (this.currentStep <= 1) return;
      this.saveDraft()
      this.currentStep -= 1
      this.$vuetify.goTo('#app')
    },
    nextForm() {
      if (this.currentStep >= this.documentSteps.length) return;
      this.saveDraft()
      this.currentStep += 1
      this.$vuetify.goTo('#app')
    },
    async saveDraft() {
      this.requestForm(this.currentStep)
      let payload = {
        ...this.formGeneral,
        ...this.formBusiness,
        ...this.formIssuesAndNeeds,
        doc_no: '123123', // require field
        doc_status: 'draft' // require field
      }
      console.log('payload: ', payload)
      let res = await this.$apiFire('Requirement/saveRequirementForm', payload)
      console.log(res)
    },
    requestForm(formStep) {
      switch (formStep) {
        case 1:
          eventBus.$emit('requirementFormGeneral')
          break

        case 2:
          eventBus.$emit('requirementFormBusiness')
          break

        case 3:
          eventBus.$emit('requirementFormIssuesAndNeeds')
          break
      }
    },
    retrieveForms() {
      // General form
      this.getFormById();
      eventBus.$on('requirementFormGeneralSend', (form) => {
        this.formGeneral = form
        // clear org data on same address case
        if (form.p1_same_addr) {
          this.formGeneral.p1_org_addr = undefined
          this.formGeneral.p1_org_pid = undefined
          this.formGeneral.p1_org_did = undefined
          this.formGeneral.p1_org_sdid = undefined
          this.formGeneral.p1_org_postcode = undefined
          this.formGeneral.p1_org_phone = undefined
          this.formGeneral.p1_org_mobile_phone = undefined
          this.formGeneral.p1_org_fax = undefined
          this.formGeneral.p1_org_email = undefined
          this.formGeneral.p1_org_website = undefined
        }
        console.log('req form page: ', this.formGeneral)
        // keep in storage
        this.$store.commit('Requirement/setGeneralForm', this.formGeneral)
      })

      // Business form
      eventBus.$on('requirementFormBusinessSend', (form) => {
        this.formBusiness = form
        // keep in storage
        this.$store.commit('Requirement/setBusinessForm', this.formBusiness)
      })

      // IssuesAndNeeds form
      eventBus.$on('requirementFormIssuesAndNeedsSend', (form) => {
        this.formIssuesAndNeeds = form
        // keep in storage
        this.$store.commit('Requirement/setIssuesAndNeedsForm', this.formIssuesAndNeeds)
      })
    },
    async getFormById () {
      let res = await this.$apiFire('Requirement/getRequirementFormById', { id: this.$route.params.id })
      console.log('getFormById response',res)
      if (res) {
        const needle = 'อื่น ๆ โปรดระบุ'
        if(res.requirementForm.p3_issue_and_req.includes(needle)){
          this.isOtherReq = true
          const index = res.requirementForm.p3_issue_and_req.indexOf(needle);
          if (index > -1) {
            res.requirementForm.p3_issue_and_req.splice(index, 1);
          }
        }
        this.form = res.requirementForm

        this.$forceUpdate()
      }else{
        this.$router.push({ name: 'RequirementList' });
      }
    },
  }
}
</script>

<style scoped>

</style>